import { ProfileFilter } from "../../../Filters/ProfileFilter";
import { Profile } from "../../../Types/Profile";
import { Client } from "../Client";
import { APIRequest, APIRequestMethod } from "../APIRequest";
import { VCardContent } from "../../../Types/VCardContent";

class ProfileAPI {
    Search(filter: ProfileFilter, embed: boolean = false): Promise<Profile[]> {
        return Client.Request(new APIRequest(APIRequestMethod.POST, '/api/profiles/search', filter).SetEmbed(embed));
    }

    Get(profileId: string, embed: boolean = false): Promise<Profile> {
        return Client.Request(new APIRequest(APIRequestMethod.GET, `/api/profiles/${profileId}`).SetEmbed(embed));
    }

    GetVCard(profileId: string): Promise<VCardContent> {
        return Client.Request(new APIRequest(APIRequestMethod.GET, `/api/profiles/${profileId}/vcard`));
    }
}

export { ProfileAPI }